// Formatação de valores monetários para o InputNumber do antd (padrão 10.000,00)

const CURRENCY_SYMBOLS = {
  BRL: 'R$',
  USD: 'US$',
  EUR: '€',
  GTQ: 'Q',
}

export const currencySymbol = currency => CURRENCY_SYMBOLS[currency] || currency || ''

// recebe o valor interno ("10000.5", "10000." enquanto digita, ou number) e devolve "R$ 10.000,5"
export const moneyFormatter = currency => (value) => {
  if (value === null || value === undefined || value === '') return ''

  const [integer, decimal] = String(value).split('.')
  const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  const formatted = decimal !== undefined ? `${grouped},${decimal}` : grouped

  return `${currencySymbol(currency)} ${formatted}`
}

// recebe o texto exibido ("R$ 10.000,50") e devolve o valor interno ("10000.50")
export const moneyParser = (text) => {
  if (!text) return ''

  const cleaned = String(text).replace(/[^\d,]/g, '')
  const [integer, ...decimals] = cleaned.split(',')

  return decimals.length > 0 ? `${integer}.${decimals.join('').slice(0, 2)}` : integer
}

export const formatMoney = (value, currency) => (
  value === null || value === undefined
    ? ''
    : moneyFormatter(currency)(Number(value).toFixed(2))
)
